import React from 'react';
import { CheckIcon, ClockIcon, LockIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { heroSpecs, PRODUCT_NAME } from '../data/content';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/aa700a46-bb75-40bd-b929-f892cffbe423.jpg';
const trust = [{
  icon: LockIcon,
  label: 'Pago seguro'
}, {
  icon: ClockIcon,
  label: 'Acceso inmediato'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía de 7 días'
}];
export function Hero() {
  return <header className="border-b border-paper-line bg-paper px-5 pb-16 pt-14 sm:pb-20 sm:pt-16 lg:px-8 lg:pb-24 lg:pt-20" data-id="element-142" data-mp="xa4ibf8y0fgn">
      <div className="mx-auto grid max-w-6xl items-center gap-12 lg:grid-cols-[1.1fr_1fr] lg:gap-16" data-id="element-143" data-mp="s9q7jpfyirex">
        <div data-id="element-144" data-mp="nbonp2apio2e">
          <p className="text-[11px] font-extrabold uppercase tracking-[0.28em] text-grass" data-id="element-145" data-mp="neaw145f97lo">
            {PRODUCT_NAME}
          </p>

          <h1 className="display mt-5 text-[2.5rem] text-ink sm:text-5xl lg:text-[4.25rem]" data-id="element-146" data-mp="382p4d9lap7jk">
            Planificá todo tu año de entrenamientos en{' '}
            <span className="text-grass" data-id="element-147" data-mp="3j9ainhg5sy79">menos de 5 minutos</span>
          </h1>

          <p className="mt-7 max-w-xl text-lg leading-relaxed text-ink-soft sm:text-xl" data-id="element-148" data-mp="3o6apvvoqw6zy">
            El set definitivo de 6 tomos más 5 bonos estratégicos. 300+ ejercicios
            listos para dar, 120+ fichas visuales y todas las herramientas para
            evaluar el progreso de tus jugadores. Ya preparado para vos.
          </p>

          <ul className="mt-8 flex flex-wrap gap-2" data-id="element-149" data-mp="30g6m9obk478y">
            {heroSpecs.map(spec => <li key={spec} className="flex items-center gap-2 rounded-full border border-paper-line bg-paper-soft px-3.5 py-2 text-[13px] font-bold uppercase tracking-wide text-ink" data-id="element-150" data-mp="35au9ljutqvly">
                <CheckIcon className="h-3.5 w-3.5 text-grass" aria-hidden="true" data-id="element-151" data-mp="2hinawe1mmcjd" />
                {spec}
              </li>)}
          </ul>

          <div className="mt-10 flex flex-col items-start gap-5" data-id="element-152" data-mp="2ljz0wkoewzs3">
            <CtaButton size="lg" data-id="element-153" data-mp="s333va8e4ivy">Quiero el megapack ahora</CtaButton>
            <ul className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-ink-dim" data-id="element-154" data-mp="nbl2il2gggag">
              {trust.map(({
              icon: Icon,
              label
            }) => <li key={label} className="flex items-center gap-2" data-id="element-155" data-mp="icrmolzp4d74">
                  <Icon className="h-4 w-4 text-grass" aria-hidden="true" data-id="element-156" data-mp="ddwzl7up42h7" />
                  {label}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="relative" data-id="element-157" data-mp="161ayhbhyf83y">
          <img src={HERO_IMAGE} alt="Un entrenador solo en una cancha de barrio al atardecer, con una pelota bajo el brazo" className="aspect-[4/3] w-full rounded-xl object-cover shadow-xl lg:aspect-[3/4]" data-id="element-158" data-mp="16342sk53hg8s" />
          <p className="absolute bottom-4 left-4 right-4 rounded-md bg-ink/85 px-4 py-3 text-sm font-medium text-white backdrop-blur-sm" data-id="element-159" data-mp="3lsp33cogahdw">
            Dejá de ser "el que pone los conos". Entrá a la cancha con el plan escrito.
          </p>
        </div>
      </div>
    </header>;
}